import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type LoginErrorKind = "inactive" | "credentials" | null;

export type LoginFailureKind = Exclude<LoginErrorKind, null>;

interface MeState {
  data: any[];
  loading: boolean;
  error: boolean;
  loginErrorKind: LoginErrorKind;
}

const initialState: MeState = {
  data: [],
  loading: false,
  error: false,
  loginErrorKind: null,
};

const meSlice = createSlice({
  name: "me",
  initialState,
  reducers: {
    getMe: (state) => {
      state.loading = true;
      state.error = false;
      state.data = [];
      state.loginErrorKind = null;
    },
    getMeSuccess: (state, actions) => {
      state.loading = false;
      state.error = false;
      state.loginErrorKind = null;
      state.data = actions.payload;
    },
    getMeFailure: (state, action: PayloadAction<LoginFailureKind>) => {
      state.loading = false;
      state.error = true;
      state.data = [];
      state.loginErrorKind = action.payload;
    },
  },
});

export const { getMe, getMeSuccess, getMeFailure } = meSlice.actions;

export default meSlice.reducer;
